module.exports = __webpack_public_path__ + "img/login_bg.1a308a5a.jpg";